import { RequestClarificationType } from '../types/types'

export const getMapHeadTitles = (): Partial<
  Record<keyof RequestClarificationType, string>
> => ({
  status: 'Статус',
  financialSourceId: 'Оплата',
  id: 'Номер заявки',
  created: 'Дата создания',
  name: 'ФИО',
  locality: 'Адрес',
  phone: 'Телефон',
  categories: 'Льготная категория',
})

export const sortedKeys = ['financialSourceId', 'id', 'created']

export const widthMap: Record<string, string> = {
  status: '5%',
  financialSourceId: '9%',
  id: '8%',
  created: '8%',
  name: '17%',
  locality: '20%',
  phone: '10%',
  categories: '15%',
}
